/**
 * @generated SignedSource<<70aebc435329540b969b5d0ab654a1c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type agendaEventNodesByIdAtom_events$data = ReadonlyArray<{
  readonly events: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly eventSessions: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"EventSlot_event">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "agendaEventNodesByIdAtom_events";
}>;
export type agendaEventNodesByIdAtom_events$key = ReadonlyArray<{
  readonly " $data"?: agendaEventNodesByIdAtom_events$data;
  readonly " $fragmentSpreads": FragmentRefs<"agendaEventNodesByIdAtom_events">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "agendaEventNodesByIdAtom_events",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventConnection",
      "kind": "LinkedField",
      "name": "events",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Event",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EventSlot_event"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventSessionConnection",
                  "kind": "LinkedField",
                  "name": "eventSessions",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EventSessionEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "EventSession",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Agenda",
  "abstractKey": null
};
})();

(node as any).hash = "72f70fb981ea43315ee502ded71732ef";

export default node;
